import React from 'react';
import { FormControl, FormLabel, Switch, NumberInput, NumberInputField, Select } from '@chakra-ui/react';

const durationTypes = ['SECONDS', 'MINUTES', 'HOURS', 'WEEKS', 'DAYS'];

const TimeBasedTargeting = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>Time Based Targeting Status</FormLabel>
        <Switch
          name="actionProps.timeBasedTargeting.status"
          isChecked={formik.values.actionProps.timeBasedTargeting.status}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Duration</FormLabel>
        <NumberInput min={0}>
          <NumberInputField
            name="actionProps.timeBasedTargeting.duration"
            value={formik.values.actionProps.timeBasedTargeting.duration}
            onChange={(valueString) => formik.setFieldValue('actionProps.timeBasedTargeting.duration', valueString.target.value)}
          />
        </NumberInput>
      </FormControl>
      <FormControl>
        <FormLabel>Duration Type</FormLabel>
        <Select
          name="actionProps.timeBasedTargeting.durationType"
          value={formik.values.actionProps.timeBasedTargeting.durationType}
          onChange={formik.handleChange}
        >
          {durationTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default TimeBasedTargeting;